import React, { Component } from "react";

class DetailTable extends Component {
  render() {
    const hasTitle = Object.prototype.hasOwnProperty.call(
      this.props,
      "title"
    );

    const title = hasTitle ? this.props.title : "";
    const children = this.props.children;

    const mt = Object.prototype.hasOwnProperty.call(this.props, "mt")
      ? this.props.mt
      : "30px";

    const containerStyle = {
      marginTop: title ? mt : "0px",
    };

    const titleStyle = {
      fontSize: "15px",
      marginBottom: "12px",
      fontWeight: 600,
      color: "#000000",
    };

    const tableStyle = {
      width: "100%",
      textAlign: "left",
      color: "#6B7280",
    };

    return (
      <div style={containerStyle}>
        {title && <h4 style={titleStyle}>{title}</h4>}

        <div>
          <table style={tableStyle}>
            <tbody>{children}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default DetailTable;